import { CommonModule } from '@angular/common';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-conclusao-tarefa',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './conclusao-tarefa.component.html',
  styleUrls: ['./conclusao-tarefa.component.scss'],
})
export class ConclusaoTarefaComponent implements OnInit {
  BASE_IMG_URL: string = environment.BASE_IMG_URL;
  @Output() close = new EventEmitter<void>();
  concluida = true;

  constructor() {}

  ngOnInit() {}

  continuar() {
    this.concluida = false;
    this.close.emit();
  }
}
